import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={20}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.408.416H1.592C.714.416 0 1.13 0 2.008v8.983c0 .878.714 1.592 1.592 1.592h16.816c.878 0 1.592-.714 1.592-1.592V2.008c0-.878-.714-1.592-1.592-1.592Zm-.61 1.053-7.49 5.214a.541.541 0 0 1-.616 0l-7.49-5.215h15.595Zm-16.745 9.23V2.007c0-.019 0-.037.003-.055l4.873 3.392-4.876 5.353Zm.666.831L6.8 5.952l2.29 1.595a1.591 1.591 0 0 0 1.82 0l2.29-1.595 5.082 5.578H1.719Zm17.229-.832-4.876-5.353 4.873-3.392a.523.523 0 0 1 .002.055v8.69Z"
      fill="#1D1D1D"
    />
  </svg>
)

export default SvgComponent